<template>
    <div id="allege">
        <Header title="申述" :show-back="true"></Header>
        <div class="allegeContent">
            <textarea name="" id="textarea" placeholder="请填写申述内容..." v-model="content"></textarea>
            <!--<van-uploader v-model="fileList" multiple>
                <div class="uploadImgBtn">
                    <img src="../../assets/img/allegeImg.png" alt=""/>
                    <span>请点击上传图片</span>
                </div>
            </van-uploader>-->
        </div>
        <button class="btn" @click="submit">提交申述</button>
    </div>
</template>

<script>
    import Header from "../../components/header";

    export default {
        name: "allege",
        components: {
            Header
        },
        data() {
            return {
                fileList: [
                    // {url: 'https://img.yzcdn.cn/vant/leaf.jpg'},
                ],
                content: ""
            }
        },
        methods: {
            submit() {
                let id = this.$route.query.id;
                let adid = this.$route.query.adid;
                let obj = {
                    oid: id,
                    aid: adid,
                    complain: this.content
                };
                this.ajax.post('appapi/c2c/complain_submit', obj).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                        this.$router.push({path: "/myC2c"});
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    #allege {
        .allegeContent {
            margin: 32px 32px 55px;
            padding: 18px 21px 48px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0 10px 18px 0 rgba(48, 77, 120, 0.06);
            border-radius: 15px;

            /deep/ .van-image {
                width: 152px;
                height: 129px;
                background: rgba(250, 250, 250, 1);
                border-radius: 15px;
            }

            #textarea {
                width: 100%;
                height: 420px;
                background: rgba(250, 250, 250, 1);
                border-radius: 10px;
                border: none;
                padding: 25px;
                margin-bottom: 53px;
                font-size: 24px;
                color: #333333;
                resize: none;
            }

            .uploadImgBtn {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px 0 4px;

                img {
                    width: 87px;
                    height: 77px;
                    margin-bottom: 7px;
                }

                span {
                    font-size: 22px;
                    font-weight: 500;
                    color: rgba(16, 145, 74, 1);
                }
            }
        }

        .btn {
            display: block;
            width: 600px;
            height: 80px;
            margin: 0 auto;
            background: rgba(31, 194, 109, 1);
            border-radius: 10px;
            font-size: 32px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
        }
    }
</style>
